export enum VacaniesTypesEnums {
  'Full time' = 1,
  'Part time' = 10,
  'Contract' = 20,
  'Freelancer' = 30,
}
